export default {
    methods: {
        showErrorMessageAlert(message = '', title = 'Hata') {
            this.$swal.fire({
                icon: 'error',
                title: title,
                text: message,
            })
        },
        showSuccessMessageAlert(message = 'İşleminiz başarılı bir şekilde yapıldı.', title = 'Başarılı') {
            this.$swal.fire({
                icon: 'success',
                title: title,
                text: message,
            })
        },
        showSuccessMessageToast(message, title = 'Başarılı') {
            this.$bvToast.toast(message, {
                title: title,
                variant: "success",
                solid: true,
                autoHideDelay: 5000,
            })
        },
        showErrorMessageToast(message, title = 'Hata') {
            this.$bvToast.toast(message, {
                title: title,
                variant: "danger",
                solid: true,
                autoHideDelay: 5000,
            })
        }
    }
}
